import { Component, OnInit, OnDestroy } from "@angular/core";
//import { Subscription } from 'rxjs';

import { ConfirmationService } from "primeng/api";
import { DialogService } from "primeng/dynamicdialog";
import { SchoolService } from "../../../shared/services/school.service";
import { UserService } from "../../../shared/services/user.service";

import { DataService_printermaint } from "./shared/data.service";
import { SchoolInfo } from "./shared/SchoolInfo";
import { wsPrintersInfo } from "./shared/wsPrintersInfo";
import { wsPrinterDeleteParm } from "./shared/wsPrinterDeleteParm";
import { wsPrinterToggleActiveParm } from "./shared/wsPrinterToggleActiveParm";
import { SchoolselectorService } from "../../schoolselector/schoolselectorservice.service";

//import { SetPrinterComponent } from './setprinter/setprinter.component';

@Component({
	selector: "app-root",
	templateUrl: "./printermaint.component.html",
	styleUrls: ["./printermaint.component.css"],
	providers: [ConfirmationService, DialogService],
})
export class PrinterMaintComponent implements OnInit, OnDestroy {
	constructor(
		private selectService: SchoolselectorService,
		private dataService: DataService_printermaint,
		private userService: UserService,
		private schoolService: SchoolService,
		private confirmationService: ConfirmationService,
		private dialogService: DialogService
	) {}

	//-----------------------------------------------------------------------------------------------------
	//
	//	Globals
	//
	//-----------------------------------------------------------------------------------------------------
	private user: any;
	public isBusy: boolean = false;
	public isShowInfo: boolean = false;
	public ErrorMessage: string = "";

	//	School Selector
	public PreSelectSchoolID: any = -1; // -1 = [no selection]
	public lstSchool: any = [];
	public SelectedSchool: SchoolInfo;

	//	Printers List
	public lstPrinters: wsPrintersInfo[] = [];
	public SelectedPrinter: wsPrintersInfo;

	//	Printers Counts
	public pagefirst: number = 0;
	public pagerows: number = 10;

	subscription: any;
	SchoolSelectShowAll: any = true;
	SchoolSelectShowAllID: any = -1;
	SchoolSelectShowAllText: any = "- Select a School -";

	//-----------------------------------------------------------------------------------------------------
	//
	//	ngOnInit
	//
	//-----------------------------------------------------------------------------------------------------
	ngOnInit() {
		this.user = this.userService.getCurrentUser();

		// this.LoadSchoolList();

		this.subscription = this.selectService.onSchoolChanged().subscribe((school) => {
			// this.SchoolID = school.SchoolID;
			this.onSchoolChange(school);
		});
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	ngOnDestroy
	//
	//-----------------------------------------------------------------------------------------------------

	ngOnDestroy() {
		this.subscription.unsubscribe();
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onToggleInfo
	//
	//-----------------------------------------------------------------------------------------------------
	onToggleInfo() {
		this.isShowInfo = !this.isShowInfo;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	IDPrintQueueSelectList_Complete
	//
	//-----------------------------------------------------------------------------------------------------
	IDPrintQueueSelectList_Complete(data: any) {
		this.SelectedPrinter = null;
		this.lstPrinters = data;
		this.isBusy = false;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onRefresh
	//
	//-----------------------------------------------------------------------------------------------------
	onRefresh() {
		this.isBusy = true;
		this.ErrorMessage = "";
		this.dataService.PrintersSelectList(this.SelectedSchool.SchoolID).subscribe((data) => this.IDPrintQueueSelectList_Complete(data));
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onRowSelect
	//
	//-----------------------------------------------------------------------------------------------------
	onRowSelect(event) {}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onRowUnselect
	//
	//-----------------------------------------------------------------------------------------------------
	onRowUnselect(event) {
		//
		//	Need to set SelectedPrinter here. We don't unselect when selected.
		//
		this.SelectedPrinter = event.data;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onDelete
	//
	//-----------------------------------------------------------------------------------------------------
	onDelete() {
		this.ErrorMessage = "";

		if (this.SelectedPrinter == null) {
			this.confirmationService.confirm({
				acceptLabel: "Ok",
				rejectVisible: false,
				message: "Please select a printer.",
				header: "Delete",
				icon: "fa fa-info",
				accept: () => {},
				reject: () => {},
			});
		} else {
			var message =
				"You are about to delete printer [" +
				this.SelectedPrinter.PrinterName +
				"] at station [" +
				this.SelectedPrinter.ScanStation +
				"].<br><br>" +
				"Do you wish to continue?";

			this.confirmationService.confirm({
				message: message,
				header: "Delete",
				icon: "fa fa-trash",
				accept: () => {
					this.onDeleteConfirmed();
				},
				reject: () => {},
			});
		}
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onDeleteConfirmed
	//
	//-----------------------------------------------------------------------------------------------------
	onDeleteConfirmed() {
		let parms: wsPrinterDeleteParm = {
			IDPrinterID: this.SelectedPrinter.IDPrinterID,
		};

		this.isBusy = true;
		this.dataService.PrinterDelete(parms).subscribe((data) => this.PrinterDelete_Complete(data));
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	PrinterDelete_Complete
	//
	//-----------------------------------------------------------------------------------------------------
	PrinterDelete_Complete(data: any) {
		this.isBusy = false;

		if (data.length > 0 && data[0] != "") {
			this.ErrorMessage = data[0];
		} else {
			//
			//	Refresh Printers
			//
			this.isBusy = true;
			this.ErrorMessage = "";
			this.dataService.PrintersSelectList(this.SelectedSchool.SchoolID).subscribe((data) => this.IDPrintQueueSelectList_Complete(data));
		}
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onToggleActive
	//
	//-----------------------------------------------------------------------------------------------------
	onToggleActive() {
		if (this.SelectedPrinter == null) {
			this.confirmationService.confirm({
				acceptLabel: "Ok",
				rejectVisible: false,
				message: "Please select a printer.",
				header: "Active/Inactive",
				icon: "fa fa-info",
				accept: () => {},
				reject: () => {},
			});
		} else {
			let parms: wsPrinterToggleActiveParm = {
				IDPrinterID: this.SelectedPrinter.IDPrinterID,
			};

			this.isBusy = true;
			this.dataService.PrinterToggleActive(parms).subscribe((data) => this.PrinterToggleActive_Complete(data));
		}
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	PrinterToggleActive_Complete
	//
	//-----------------------------------------------------------------------------------------------------
	PrinterToggleActive_Complete(data: any) {
		this.isBusy = false;

		if (data.length > 0 && data[0] != "") {
			this.ErrorMessage = data[0];
		} else {
			//
			//	Refresh Printers
			//
			this.isBusy = true;
			this.ErrorMessage = "";
			this.dataService.PrintersSelectList(this.SelectedSchool.SchoolID).subscribe((data) => this.IDPrintQueueSelectList_Complete(data));
		}
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	LoadSchoolList
	//
	//-----------------------------------------------------------------------------------------------------
	LoadSchoolList() {
		var result = this.schoolService.loadSchoolList("");

		result.subscribe(
			(response) => {
				this.lstSchool = response;
				let isItemFound: boolean = false;
				let isSchoolSelected: boolean = false;

				//
				//	Add the [- Select a school -] to the top of the list
				//
				//	Note: "- Select a school" is put in SchoolNumber to match the HTML formatting.
				//		this allows it to show with a visual appeal that matches the rest of the items.
				//
				this.lstSchool.unshift({
					SchoolID: -1,
					SchoolNumber: "- Select a school",
					SchoolName: "",
				});

				//
				//	if PreSelectSchoolID has a value not equal -1 then try to select the item
				//
				this.lstSchool.forEach((item) => {
					if (this.PreSelectSchoolID == item.SchoolID && isItemFound == false && this.PreSelectSchoolID != -1) {
						this.SelectedSchool = item;
						isItemFound = true;
						isSchoolSelected = true;
					}
				});

				//
				//	if PreSelectSchoolID was not found
				//
				if (isItemFound == false) {
					//
					//	If there is only 1 school in list and (PreSelectSchoolID = -1 or PreSelectSchoolID matched the school)
					//	then select it. otherwise select the [- Select a School -] item.
					//
					if (this.lstSchool.length == 2) {
						if (this.PreSelectSchoolID == -1 || this.PreSelectSchoolID == this.lstSchool[1].SchoolID) {
							this.SelectedSchool = this.lstSchool[1];
							isSchoolSelected = true;
						} else {
							this.SelectedSchool = this.lstSchool[0];
						}
					} else {
						this.SelectedSchool = this.lstSchool[0];
					}
				}

				this.isBusy = false;

				if (isSchoolSelected == true) {
					this.isBusy = true;
					this.ErrorMessage = "";
					this.dataService.PrintersSelectList(this.SelectedSchool.SchoolID).subscribe((data) => this.IDPrintQueueSelectList_Complete(data));
				}
			},
			(error) => {}
		);
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onSchoolChange
	//
	//-----------------------------------------------------------------------------------------------------
	onSchoolChange(value) {
		this.SelectedSchool = value;

		if (this.SelectedSchool.SchoolID > 0) {
			this.isBusy = true;
			this.ErrorMessage = "";
			this.dataService.PrintersSelectList(this.SelectedSchool.SchoolID).subscribe((data) => this.IDPrintQueueSelectList_Complete(data));
		} else {
			this.isBusy = false;
			this.lstPrinters = [];
		}
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	Add New Method Here
	//
	//-----------------------------------------------------------------------------------------------------
}
